import "./QuestionsView.css";
import { Spacer, Tabs } from "@geist-ui/react";
import { FaBullhorn, FaFire } from "react-icons/fa";
import QuestionsGen from "./QuestionsGen";

function QuestionsView() {
  return (
    <Tabs initialValue="1">
      <Tabs.Item
        label={
          <>
            <FaBullhorn />
            <Spacer x={0.3} />
            Latest
          </>
        }
        value="1"
      >
        <Spacer y={0.5} />
        <QuestionsGen filter="latest" />
      </Tabs.Item>
      <Tabs.Item
        label={
          <>
            <FaFire />
            <Spacer x={0.3} />
            Hot
          </>
        }
        value="2"
      >
        <Spacer y={0.5} />
        <QuestionsGen filter="hot" />
      </Tabs.Item>
    </Tabs>
  );
}

export default QuestionsView;
